<template>
  <div class="stepContainer step1">
    <step-header v-if="courseInfo" :title="courseInfo.courseName"/>
    <div class="layout clearfix">
      <div class="input-row clearfix">
        <span class="tits">请输入准考证号：</span>
        <input type="text" placeholder="请输入模拟准考证号" class="zkz" v-model="zkzID"/>
      </div>
      <div class="btn-row clearfix">
        <a href="javascript:void(0)" class="goNext" @click="goNext">登 录</a>
      </div>
    </div>
  </div>
</template>
<script>
  import { StepHeader } from "@components/common"
  import { mapGetters } from 'vuex'
  import { setPageTitle, isEmptyObject, parseNumber } from "@/utils"


  export default {
    name: 'Step1',
    components: {
      StepHeader
    },
    computed: {
      ...mapGetters([
        'siteData'
      ])
    },
    data() {
      return {
        courseInfo: null,
        siteCourseID: '',
        courseID: '',
        isShow: true,
        zkzID: '1234'
      }
    },
    async mounted() {
      const { flag } = this.$route.params
      let _flag = flag === 'paidExam' ? '' : flag
      const { courseID, siteCourseID } = this.$route.query
      const { majorID } = this.$categoryInfo
      this.isShow = false
      this.courseID = courseID
      this.siteCourseID = parseNumber(siteCourseID)

      if (isEmptyObject(this.siteData)) {
        let params = {
          flag: _flag,
          majorID: majorID,
          siteCourseID: this.siteCourseID
        }
        await this.$store.dispatch('getCurrentSiteInfo', params)
        .then(res => {
          this.courseInfo = res.currentCourse
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
      } else {
        this.courseInfo = this.siteData.currentCourse
      }
      document.title = setPageTitle(this.courseInfo && this.courseInfo.siteCourseName)
    },
    methods: {
      goNext() {
        if (this.zkzID.trim() === '' || this.zkzID.trim() !== '1234') {
          alert('请输入模拟准考证号1234!')
        } else {
          const { flag } = this.$route.query
          if (flag === 'ordinary') {
            this.$router.push({
              path: 'step2',
              query: {
                ...this.$route.query
              }
            })
            
          } else {
            this.$router.push({
              path: 'step2',
              query: {
                siteCourseID: this.siteCourseID,
                courseID: this.courseID
              }
            })
          }
        }
      }
    }
  }
</script>
